// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-form {
  visibility: hidden;
  position: fixed;
  display: flex;
  width: 20rem;
  top: 10rem;
  flex-direction: column;
  background-color: white;
  z-index: 1;
  box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.25);
  border-radius: 1rem;
}
.client-form__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 3rem;
  border-bottom: 0.0625rem solid #ddd;
}
.client-form__header__title {
  margin-left: 2rem;
  font-size: 1rem;
  color: #000;
}
.client-form__header__close {
  scale: 0.7;
  cursor: pointer;
}
.client-form__header img {
  margin-right: 1rem;
  cursor: pointer;
}
.client-form__title {
  color: #000;
  font-size: 2rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.client-form__inputs {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 2rem;
}
.client-form__inputs__one {
  color: #000;
  width: 100%;
}
.client-form__inputs__email-locked {
  width: 100%;
  cursor: not-allowed;
}
.client-form__inputs__email-locked .Mui-disabled {
  cursor: not-allowed;
}
.client-form__footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 3rem;
  border-radius: 0 0 1rem 1rem;
  cursor: pointer;
}
.client-form__footer__button {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  width: 6rem;
  height: 1.5rem;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: #EF936C;
  margin-right: 2rem;
}
.client-form #demo-multiple-chip {
  margin-top: 1rem;
  max-height: 8.6rem;
  overflow-y: auto;
}
.client-form #demo-multiple-chip::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
  border: 0.0625rem solid black;
}
.client-form #demo-multiple-chip::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.client-form #demo-multiple-chip::-webkit-scrollbar-thumb {
  background: #EF936C;
  width: 80%;
}
.client-form #demo-multiple-chip::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.visible {
  visibility: visible !important;
  opacity: 1;
  transition: visibility 0s, opacity 0.5s linear;
}`, "",{"version":3,"sources":["webpack://./src/features/admin/components/client-form/client-form.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;AACJ;AAAI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;AAER;AADQ;EACI,iBAAA;EACA,eAAA;EACA,WAAA;AAGZ;AADQ;EACI,UAAA;EAEA,eAAA;AAEZ;AAAQ;EACI,kBAAA;EACA,eAAA;AAEZ;AACI;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACR;AACI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AACR;AAAQ;EACI,WAAA;EACA,WAAA;AAEZ;AAAQ;EACI,WAAA;EACA,mBAAA;AAEZ;AADY;EACI,mBAAA;AAGhB;AACI;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AACR;AAAQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAEZ;AACI;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;AACR;AAAQ;EACI,aAAA;EACA,cAAA;EACA,6BAAA;AAEZ;AACQ;EACI,mBAAA;AACZ;AACQ;EACI,mBAAA;EACA,UAAA;AACZ;AACQ;EACI,gBAAA;AACZ;;AAGA;EACI,8BAAA;EACA,UAAA;EACA,8CAAA;AAAJ","sourcesContent":[".client-form{\n    visibility: hidden;\n    position: fixed;\n    display: flex;\n    width: 20rem;\n    top:10rem;\n    flex-direction: column;\n    background-color: white;\n    z-index: 1;\n    box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.25);\n    border-radius: 1rem;\n    &__header{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        height: 3rem;\n        border-bottom: 0.0625rem solid #ddd;\n        &__title{\n            margin-left: 2rem;\n            font-size: 1rem;\n            color: #000;\n        }\n        &__close{\n            scale: 0.7;\n            \n            cursor: pointer;\n        }\n        img{\n            margin-right: 1rem;\n            cursor: pointer;\n        }\n    }\n    &__title{\n        color: #000;\n        font-size: 2rem;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n    }\n    &__inputs{\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        margin: 2rem;\n        &__one{\n            color:#000;\n            width: 100%;\n        }\n        &__email-locked{\n            width: 100%;\n            cursor: not-allowed;\n            .Mui-disabled{\n                cursor: not-allowed;\n            }\n        }\n    }\n    &__footer{\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n        width: 100%;\n        height: 3rem;\n        border-radius: 0 0 1rem 1rem;\n        cursor: pointer;\n        &__button{\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            color:#000;\n            width: 6rem;\n            height: 1.5rem;\n            font-size: 1rem;\n            border-radius: 1rem;\n            background-color: #EF936C;\n            margin-right: 2rem;\n        }\n    }\n    #demo-multiple-chip{\n        margin-top: 1rem;\n        max-height: 8.6rem;\n        overflow-y: auto;\n        &::-webkit-scrollbar {\n            width: 0.5rem;\n            height: 0.5rem;\n            border: 0.0625rem solid black;\n            \n        }\n        &::-webkit-scrollbar-track {\n            background: #f1f1f1;\n        }\n        &::-webkit-scrollbar-thumb {\n            background: #EF936C;\n            width: 80%;\n        }\n        &::-webkit-scrollbar-thumb:hover {\n            background: #555;\n        }\n    }\n}\n.visible{\n    visibility: visible !important;\n    opacity: 1;\n    transition: visibility 0s, opacity 0.5s linear;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
